import _defineProperty from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    },
    attrs: {
      id: "productList"
    }
  }, [_vm.erpSyncDatetime ? _c("a-alert", {
    attrs: {
      message: _vm.$t("productList.hint"),
      description: _vm.synchronizedStockTimeStr,
      type: "warning",
      "show-icon": "",
      closable: ""
    },
    on: {
      close: _vm.onClose
    }
  }) : _vm._e(), _c("a-card", {
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticClass: "table-page-search-wrapper"
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      "label-col": {
        span: 15
      },
      "wrapper-col": {
        span: 10
      }
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.queryProductList();
      }
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.productName")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      maxLength: 200
    },
    model: {
      value: _vm.queryParam.productName,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productName", $$v);
      },
      expression: "queryParam.productName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.productNo"),
      labelCol: {
        span: 5,
        offset: 0
      }
    }
  }, [_c("a-input-group", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      compact: ""
    }
  }, [_c("a-input", {
    staticStyle: {
      flex: "1 1 42%"
    },
    model: {
      value: _vm.queryParam.startProductNo,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "startProductNo", $$v);
      },
      expression: "queryParam.startProductNo"
    }
  }), _c("a-input", {
    staticStyle: {
      flex: "1 1 16%",
      "pointer-events": "none",
      backgroundColor: "#fff"
    },
    attrs: {
      placeholder: "~",
      disabled: ""
    }
  }), _c("a-input", {
    staticClass: "inputGroupOfRight",
    staticStyle: {
      flex: "1 1 42%"
    },
    model: {
      value: _vm.queryParam.endProductNo,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "endProductNo", $$v);
      },
      expression: "queryParam.endProductNo"
    }
  })], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.productCategory")
    }
  }, [_c("tree-select", {
    staticClass: "maxlengh",
    staticStyle: {
      width: "100%"
    },
    attrs: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      allowClear: ""
    }, "allowClear", ""), "maxTagCount", 1), "tree-data", _vm.categoryList), "tree-checkable", ""), "show-checked-strategy", _vm.SHOW_PARENT), "placeholder", _vm.$t("public.pleaseSelect")), "treeNodeFilterProp", "title"), "dropdown-style", {
      maxHeight: "400px",
      overflow: "auto"
    }), "replace-fields", {
      children: "childrenList",
      key: "id",
      value: "id",
      title: "categoryName"
    }),
    model: {
      value: _vm.queryParam.productClassify,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productClassify", $$v);
      },
      expression: "queryParam.productClassify"
    }
  }, [_c("span", {
    attrs: {
      slot: "maxTagPlaceholder"
    },
    slot: "maxTagPlaceholder"
  }, [_vm._v("+" + _vm._s(_vm.queryParam.productClassify.length - 1))])])], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("newProductList.srx")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.supplierCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "supplierCode", $$v);
      },
      expression: "queryParam.supplierCode"
    }
  }, _vm._l(_vm.srxList, function (one, index) {
    return _c("a-select-option", {
      key: one.id,
      attrs: {
        value: one.id
      }
    }, [_vm._v(_vm._s(one.name))]);
  }), 1)], 1)], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showAdvanced,
      expression: "showAdvanced"
    }]
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: "JAN"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      maxLength: 200
    },
    model: {
      value: _vm.queryParam.productBarcode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productBarcode", $$v);
      },
      expression: "queryParam.productBarcode"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.stockNum"),
      labelCol: {
        span: 5,
        offset: 0
      }
    }
  }, [_c("a-input-group", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      compact: ""
    }
  }, [_c("a-input-number", {
    staticStyle: {
      flex: "1 1 42%",
      "text-align": "center",
      width: "auto"
    },
    attrs: {
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.queryParam.startProductStocknum,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "startProductStocknum", $$v);
      },
      expression: "queryParam.startProductStocknum"
    }
  }), _c("a-input", {
    staticStyle: {
      flex: "1 1 16%",
      "border-left": "0",
      "pointer-events": "none",
      backgroundColor: "#fff"
    },
    attrs: {
      placeholder: "~",
      disabled: ""
    }
  }), _c("a-input-number", {
    staticStyle: {
      flex: "1 1 42%",
      "text-align": "center",
      "border-left": "0",
      width: "auto"
    },
    attrs: {
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.queryParam.endProductStocknum,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "endProductStocknum", $$v);
      },
      expression: "queryParam.endProductStocknum"
    }
  })], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.shelfTime"),
      labelCol: {
        span: 5,
        offset: 0
      }
    }
  }, [_c("a-range-picker", {
    attrs: {
      valueFormat: "YYYY-MM-DD",
      placeholder: ["", ""],
      allowClear: ""
    },
    on: {
      change: function change() {}
    },
    model: {
      value: _vm.queryParam.productShelfTime,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productShelfTime", $$v);
      },
      expression: "queryParam.productShelfTime"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.createTime"),
      labelCol: {
        span: 5,
        offset: 0
      }
    }
  }, [_c("a-range-picker", {
    attrs: {
      valueFormat: "YYYY-MM-DD",
      placeholder: ["", ""],
      allowClear: ""
    },
    on: {
      change: function change() {}
    },
    model: {
      value: _vm.queryParam.productCreateTime,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productCreateTime", $$v);
      },
      expression: "queryParam.productCreateTime"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.productStatus")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.productStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productStatus", $$v);
      },
      expression: "queryParam.productStatus"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("productList.onTheShelf")))]), _c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("productList.offTheShelf")))]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v(_vm._s(_vm.$t("newProductList.overSell")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.transportMode")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.transportType,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "transportType", $$v);
      },
      expression: "queryParam.transportType"
    }
  }, _vm._l(_vm.transportModeList, function (one) {
    return _c("a-select-option", {
      attrs: {
        value: one.id
      }
    }, [_vm._v(_vm._s(one.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.brand")
    }
  }, [_c("a-select", {
    attrs: {
      showSearch: "",
      optionFilterProp: "children",
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.productBrandid,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productBrandid", $$v);
      },
      expression: "queryParam.productBrandid"
    }
  }, _vm._l(_vm.brandList, function (one) {
    return _c("a-select-option", {
      attrs: {
        value: one.id
      }
    }, [_vm._v(_vm._s(one.name))]);
  }), 1)], 1)], 1), _vm.deliveryChannel == 1 || _vm.deliveryChannel == null || _vm.deliveryChannel == undefined ? _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.deliveryChannel")
    }
  }, [_vm.deliveryChannelList.length > 0 ? _c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.productChannelid,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productChannelid", $$v);
      },
      expression: "queryParam.productChannelid"
    }
  }, _vm._l(_vm.deliveryChannelList, function (one, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: one.id
      }
    }, [_vm._v(_vm._s(one.name))]);
  }), 1) : _vm._e()], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.sourceArea")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.productSourceareaid,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productSourceareaid", $$v);
      },
      expression: "queryParam.productSourceareaid"
    }
  }, _vm._l(_vm.sourceAreaList, function (one) {
    return _c("a-select-option", {
      attrs: {
        value: one.id
      }
    }, [_vm._v(_vm._s(one.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.choiceDays"),
      labelCol: {
        span: 5,
        offset: 0
      }
    }
  }, [_c("a-input-group", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      compact: ""
    }
  }, [_c("a-input-number", {
    staticStyle: {
      flex: "1 1 42%",
      "text-align": "center",
      width: "auto"
    },
    attrs: {
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.queryParam.startStockDay,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "startStockDay", $$v);
      },
      expression: "queryParam.startStockDay"
    }
  }), _c("a-input", {
    staticStyle: {
      flex: "1 1 16%",
      "border-left": "0",
      "pointer-events": "none",
      backgroundColor: "#fff"
    },
    attrs: {
      placeholder: "~",
      disabled: ""
    }
  }), _c("a-input-number", {
    staticStyle: {
      flex: "1 1 42%",
      "text-align": "center",
      "border-left": "0",
      width: "auto"
    },
    attrs: {
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.queryParam.endStockDay,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "endStockDay", $$v);
      },
      expression: "queryParam.endStockDay"
    }
  })], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("newProductList.visitorVisible"),
      labelCol: {
        span: 10,
        offset: 0
      },
      wrapperCol: {
        span: 5
      }
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.touristView,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "touristView", $$v);
      },
      expression: "queryParam.touristView"
    }
  }, _vm._l(_vm.visitorVisibleList, function (one) {
    return _c("a-select-option", {
      attrs: {
        value: one.id
      }
    }, [_vm._v(_vm._s(one.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.ERPSynchronizedStockSwitch")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      "default-value": 0,
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.stockSyn,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "stockSyn", $$v);
      },
      expression: "queryParam.stockSyn"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("productList.open")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("productList.close")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("productList.productBelong")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.productBelong,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "productBelong", $$v);
      },
      expression: "queryParam.productBelong"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("productList.other")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("productList.self")))])], 1)], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: _vm.actionWidth
    }
  }, [_c("span", {
    staticClass: "table-page-search-submitButtons",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.queryLoading
    },
    on: {
      click: function click($event) {
        return _vm.queryProductList();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.inquire2")))]), _c("a", {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      click: function click() {
        _vm.showAdvanced = !_vm.showAdvanced;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.showAdvanced ? _vm.$t("productList.closeUp") : _vm.$t("productList.openDown")) + " "), _c("a-icon", {
    attrs: {
      type: _vm.showAdvanced ? "up" : "down"
    }
  })], 1)], 1)])], 1)], 1)], 1)]), _c("a-card", {
    staticStyle: {
      "margin-top": "24px",
      position: "relative",
      flex: "1 1 0%",
      "min-width": "1450px"
    },
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm.selectedRowKeys.length ? _c("a-popconfirm", {
    attrs: {
      title: _vm.$t("public.overSellPromp"),
      "ok-text": _vm.$t("public.confirm"),
      "cancel-text": _vm.$t("public.cancel")
    },
    on: {
      confirm: function confirm($event) {
        return _vm.changProductStatus(3);
      }
    }
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.overSell")))])], 1) : _c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      loading: _vm.changProductStatus3Loading
    },
    on: {
      click: function click($event) {
        return _vm.changProductStatus(3);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.overSell")))]), _c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      loading: _vm.changProductStatus1Loading
    },
    on: {
      click: function click($event) {
        return _vm.changProductStatus(2);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("productList.offTheShelf")))]), _c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      loading: _vm.changProductStatus2Loading
    },
    on: {
      click: function click($event) {
        return _vm.changProductStatus(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("productList.onTheShelf")))]), _c("a-button", {
    attrs: {
      loading: _vm.syncLoading
    },
    on: {
      click: _vm.syncProduct
    }
  }, [_vm._v(_vm._s(_vm.$t("newProductList.productSync")))]), _c("a-divider", {
    attrs: {
      type: "vertical"
    }
  }), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.addProduct();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("productList.addButton")))])], 1), _c("a-table", {
    staticClass: "components-table-demo-nested",
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      expandedRowKeys: _vm.curExpandedRowKeys,
      rowKey: "id",
      rowClassName: _vm.getRowClass,
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.productList,
      "row-selection": {
        selectedRowKeys: _vm.selectedRowKeys,
        onChange: _vm.onSelectChange,
        getCheckboxProps: _vm.getCheckboxProps
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + _vm.totalNum;
        },
        current: _vm.page,
        pageSize: _vm.size,
        total: _vm.totalNum
      }
    },
    on: {
      expand: _vm.expand,
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "productNoScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [[record.specFlag != 2 ? [_vm._v(" ...(" + _vm._s(record.specCount) + ") ")] : [record.productNo ? [_vm._v(" " + _vm._s(record.productNo) + " ")] : [_vm._v(" -- ")]]]], 2);
      }
    }, {
      key: "capacity",
      fn: function fn(text, record) {
        return _c("span", {}, [[record.specFlag != 2 ? [_vm._v(" -- ")] : [record.capacity ? [_vm._v(" " + _vm._s(record.capacity) + " ")] : [_vm._v(" -- ")]]]], 2);
      }
    }, {
      key: "listImgSrcScopedSlots",
      fn: function fn(text, record) {
        return _c("img", {
          staticStyle: {
            height: "88px",
            width: "88px"
          },
          attrs: {
            src: text ? text : _vm.productDefaultImg
          }
        });
      }
    }, {
      key: "productNameScopedSlots",
      fn: function fn(text, record) {
        return _c("a", {
          staticStyle: {
            "text-decoration": "underline"
          },
          on: {
            click: function click($event) {
              return _vm.editProduct(record);
            }
          }
        }, [_vm._v(_vm._s(text))]);
      }
    }, {
      key: "deliveryChannelScopedSlots",
      fn: function fn(text, record) {
        return _vm.deliveryChannel == 1 || _vm.deliveryChannel == null || _vm.deliveryChannel == undefined ? _c("span", {}, [record.specFlag != 2 ? [_vm._v(" -- ")] : [record.productChannel ? [_vm._v(" " + _vm._s(record.productChannel) + " ")] : [_vm._v(" -- ")]]], 2) : _vm._e();
      }
    }, {
      key: "stockNumScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [record.specFlag != 2 ? [_vm._v(" -- ")] : [_c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [record.selfStocknum !== 0 || record.otherStocknum !== 0 ? _c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(_vm.$t("productList.selfStocknum")) + ":" + _vm._s(record.selfStocknum)), _c("br"), _vm._v(" " + _vm._s(_vm.$t("productList.otherStocknum")) + ":" + _vm._s(record.otherStocknum) + " ")]) : _vm._e(), _c("span", [_vm._v(_vm._s(text))])], 2)]], 2);
      }
    }, {
      key: "sellPriceScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [[record.specFlag != 2 ? [_vm._v(" -- ")] : [_vm._v(" " + _vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm._f("toThousandslsFilter")(text)) + _vm._s(_vm.rightCurrencySymbol) + " ")]], _c("br"), [record.specFlag != 2 ? [_vm._v(" -- ")] : [_vm._v(" " + _vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm._f("toThousandslsFilter")(record.productDiscountPrice)) + _vm._s(_vm.rightCurrencySymbol) + " ")]]], 2);
      }
    }, {
      key: "updateTimeScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [record.specFlag != 2 ? [_vm._v(" -- ")] : [record.lastUpdateTime ? [_vm._v(" " + _vm._s(text.split(" ")[0]) + " "), _c("br"), _vm._v(" " + _vm._s(text.split(" ")[1]) + " ")] : [_vm._v(" -- ")]]], 2);
      }
    }, {
      key: "statusScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [record.specFlag != 2 ? [_c("div", {
          staticStyle: {
            "text-align": "left",
            "white-space": "nowrap"
          }
        }, [_c("div", {
          staticStyle: {
            "margin-bottom": "4px"
          }
        }, [_c("a-tag", {
          staticClass: "stopTag",
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.onTheShelf")))]), _vm._v("：" + _vm._s(record.productOnCount))], 1), _c("div", {
          staticStyle: {
            "margin-bottom": "4px"
          }
        }, [_c("a-tag", {
          staticClass: "stopTag",
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.offTheShelf")))]), _vm._v("：" + _vm._s(record.productOffCount))], 1), _c("div", [_c("a-tag", {
          staticClass: "stopTag",
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("newProductList.overSell")))]), _vm._v("：" + _vm._s(record.productStopCount))], 1)])] : [text == 0 ? [_c("a-tag", {
          staticClass: "stopTag",
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.offTheShelf")))])] : text == 1 ? [_c("a-tag", {
          staticClass: "stopTag",
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.onTheShelf")))])] : [_c("a-tag", {
          staticClass: "stopTag",
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("public.overSell")))])]]], 2);
      }
    }, {
      key: "productOnlinedateScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [text ? [_vm._v(" " + _vm._s(text) + " ")] : [_vm._v(" -- ")]], 2);
      }
    }, {
      key: "createTimeErpScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [record.specFlag != 2 ? [_vm._v(" -- ")] : [record.erpCreateTime ? [_vm._v(" " + _vm._s(text.split(" ")[0]) + " "), _c("br"), _vm._v(" " + _vm._s(text.split(" ")[1]) + " ")] : [_vm._v(" -- ")]]], 2);
      }
    }, {
      key: "visitorVisibleScopedSlots",
      fn: function fn(text, record) {
        return _c("span", {}, [record.specFlag != 2 ? [_vm._v("--")] : [record.productStatus == 1 || record.productStatus == 0 ? [record.touristView == 0 ? [record.touristViewJumpFlag ? _c("a", {
          staticStyle: {
            "text-decoration": "underline"
          },
          on: {
            click: function click($event) {
              return _vm.gotoVisible(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("newProductList.noVisible")))]) : _c("span", [_vm._v(_vm._s(_vm.$t("newProductList.noVisible")))])] : [_vm._v(_vm._s(_vm.$t("newProductList.visible")))]] : [_vm._v("--")]]], 2);
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a", {
          on: {
            click: function click($event) {
              return _vm.editProduct(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("public.edit")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-dropdown", {
          attrs: {
            trigger: ["click"]
          },
          model: {
            value: record.deleteVisible,
            callback: function callback($$v) {
              _vm.$set(record, "deleteVisible", $$v);
            },
            expression: "record.deleteVisible"
          }
        }, [_c("a", {
          on: {
            click: function click(e) {
              return e.preventDefault();
            }
          }
        }, [_c("a", [_vm._v(_vm._s(_vm.$t("public.more")))]), _c("a-icon", {
          attrs: {
            type: "down"
          }
        })], 1), _c("a-menu", {
          attrs: {
            slot: "overlay"
          },
          on: {
            click: function click($event) {
              return _vm.handleMenuClick(record);
            }
          },
          slot: "overlay"
        }, [record.productStatus !== 1 ? _c("a-menu-item", [_c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.deletePromp"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.deleteOneProductConfirm(record);
            },
            cancel: function cancel($event) {
              return _vm.deleteOneCancel(record);
            }
          }
        }, [_c("div", [_vm._v(_vm._s(_vm.$t("public.delete")))])])], 1) : _vm._e(), _c("a-menu-item", [_c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.copyPromp"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.copyOneProductConfirm(record);
            },
            cancel: function cancel($event) {
              return _vm.copyOneCancel(record);
            }
          }
        }, [_c("div", [_vm._v(_vm._s(_vm.$t("public.copy")))])])], 1)], 1)], 1)], 1);
      }
    }, {
      key: "expandedRowRender",
      fn: function fn(record) {
        return record.innerData.length > 0 ? _c("a-table", {
          attrs: {
            rowKey: "id",
            columns: _vm.innerColumns,
            "data-source": record.innerData,
            pagination: false
          },
          scopedSlots: _vm._u([{
            key: "createTimeErpScopedSlots",
            fn: function fn(text, record) {
              return _c("span", {}, [[record.erpCreateTime ? [_vm._v(" " + _vm._s(text.split(" ")[0]) + " "), _c("br"), _vm._v(" " + _vm._s(text.split(" ")[1]) + " ")] : [_vm._v(" " + _vm._s("--") + " ")]]], 2);
            }
          }, {
            key: "capacity",
            fn: function fn(text, record) {
              return _c("span", {}, [[record.capacity ? [_vm._v(" " + _vm._s(record.capacity) + " ")] : [_vm._v(" -- ")]]], 2);
            }
          }, {
            key: "productNoScopedSlots",
            fn: function fn(text, record) {
              return _c("span", {}, [[record.productNo ? [_vm._v(" " + _vm._s(record.productNo) + " ")] : [_vm._v(" -- ")]]], 2);
            }
          }, {
            key: "visitorVisibleScopedSlots",
            fn: function fn(text, record) {
              return _c("span", {}, [record.productStatus == 1 || record.productStatus == 0 ? [record.touristView == 0 ? [record.touristViewJumpFlag ? _c("a", {
                staticStyle: {
                  "text-decoration": "underline"
                },
                on: {
                  click: function click($event) {
                    return _vm.gotoVisible(record);
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t("newProductList.noVisible")))]) : _c("span", [_vm._v(_vm._s(_vm.$t("newProductList.noVisible")))])] : [_vm._v(_vm._s(_vm.$t("newProductList.visible")))]] : [_vm._v(" -- ")]], 2);
            }
          }, {
            key: "statusScopedSlots",
            fn: function fn(text, record) {
              return _c("span", {}, [text == 0 ? [_c("a-tag", {
                staticClass: "stopTag",
                attrs: {
                  color: "red"
                }
              }, [_vm._v(_vm._s(_vm.$t("productList.offTheShelf")))])] : text == 1 ? [_c("a-tag", {
                staticClass: "stopTag",
                attrs: {
                  color: "blue"
                }
              }, [_vm._v(_vm._s(_vm.$t("productList.onTheShelf")))])] : [_c("a-tag", {
                staticClass: "stopTag",
                attrs: {
                  color: "red"
                }
              }, [_vm._v(_vm._s(_vm.$t("public.overSell")))])]], 2);
            }
          }, {
            key: "productOnlinedateScopedSlots",
            fn: function fn(text, record) {
              return _c("span", {}, [text ? [_vm._v(" " + _vm._s(text) + " ")] : [_vm._v(" -- ")]], 2);
            }
          }, {
            key: "stockNumScopedSlots",
            fn: function fn(text, record) {
              return _c("span", {}, [[_c("a-tooltip", {
                attrs: {
                  placement: "top"
                }
              }, [record.selfStocknum !== 0 || record.otherStocknum !== 0 ? _c("template", {
                slot: "title"
              }, [_vm._v(" " + _vm._s(_vm.$t("productList.selfStocknum")) + ":" + _vm._s(record.selfStocknum)), _c("br"), _vm._v(" " + _vm._s(_vm.$t("productList.otherStocknum")) + ":" + _vm._s(record.otherStocknum) + " ")]) : _vm._e(), _c("span", [_vm._v(_vm._s(text))])], 2)]], 2);
            }
          }, {
            key: "sellPriceScopedSlots",
            fn: function fn(text, record) {
              return _c("span", {}, [[_vm._v(" " + _vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm._f("toThousandslsFilter")(text)) + _vm._s(_vm.rightCurrencySymbol) + " ")], _c("br"), [_vm._v(" " + _vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm._f("toThousandslsFilter")(record.productDiscountPrice)) + _vm._s(_vm.rightCurrencySymbol) + " ")]], 2);
            }
          }, {
            key: "updateTimeScopedSlots",
            fn: function fn(text, record) {
              return _c("span", {}, [record.lastUpdateTime ? [_vm._v(" " + _vm._s(text.split(" ")[0]) + " "), _c("br"), _vm._v(" " + _vm._s(text.split(" ")[1]) + " ")] : [_vm._v(" -- ")]], 2);
            }
          }, {
            key: "operation",
            fn: function fn(text, innerRecord) {
              return _c("span", {
                staticClass: "table-operation"
              }, [innerRecord.productStatus == 1 ? _c("a-button", {
                attrs: {
                  type: "link",
                  loading: innerRecord["updateStatusLoading" + innerRecord.id + 0]
                },
                on: {
                  click: function click($event) {
                    return _vm.updateStatus(innerRecord, 0, record);
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t("productList.offTheShelf")))]) : _vm._e(), innerRecord.productStatus == 0 ? _c("a-button", {
                attrs: {
                  type: "link",
                  loading: innerRecord["updateStatusLoading" + innerRecord.id + 1]
                },
                on: {
                  click: function click($event) {
                    return _vm.updateStatus(innerRecord, 1, record);
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t("productList.onTheShelf")))]) : _vm._e(), innerRecord.productStatus == 0 || innerRecord.productStatus == 1 ? _c("a-divider", {
                attrs: {
                  type: "vertical"
                }
              }) : _vm._e(), innerRecord.productStatus == 0 || innerRecord.productStatus == 1 ? _c("a-button", {
                attrs: {
                  type: "link",
                  loading: innerRecord["updateStatusLoading" + innerRecord.id + 2]
                },
                on: {
                  click: function click($event) {
                    return _vm.updateStatus(innerRecord, 2, record);
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t("newProductList.overSell")))]) : _vm._e()], 1);
            }
          }], null, false, 4239522163)
        }, [_c("span", {
          attrs: {
            slot: "productNoSlots"
          },
          slot: "productNoSlots"
        }, [_vm._v(" " + _vm._s(_vm.$t("productList.productNo")) + " ")]), _c("span", {
          attrs: {
            slot: "sellPriceSlots"
          },
          slot: "sellPriceSlots"
        }, [_vm._v(" " + _vm._s(_vm.$t("productList.sellPrice")) + _vm._s(_vm.$t("productList.taxIncluded")) + " "), _c("br"), _vm._v(" " + _vm._s(_vm.$t("productList.activityPrice")) + _vm._s(_vm.$t("productList.taxIncluded")) + " ")])]) : _c("p", {
          staticClass: "noInnerData",
          attrs: {
            slot: "expandedRowRender"
          },
          slot: "expandedRowRender"
        }, [_vm._v(_vm._s(_vm.$t("productList.noInnerData")))]);
      }
    }], null, true)
  }, [_c("span", {
    attrs: {
      slot: "productNoSlots"
    },
    slot: "productNoSlots"
  }, [_vm._v(" " + _vm._s(_vm.$t("productList.productNo")) + " ")]), _c("span", {
    attrs: {
      slot: "sellPriceSlots"
    },
    slot: "sellPriceSlots"
  }, [_vm._v(" " + _vm._s(_vm.$t("productList.sellPrice")) + _vm._s(_vm.$t("productList.taxIncluded"))), _c("br"), _vm._v(" " + _vm._s(_vm.$t("productList.activityPrice")) + _vm._s(_vm.$t("productList.taxIncluded")) + " ")])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };